export const METER_SCOPE_NAMES = {
  full: 'full',
  minimal: 'minimal',
  list: 'list',
} as const;
